export default "__VITE_ASSET__CFWsOCRp__"